export default "__VITE_ASSET__C0_32GEA__"